import { Theme, Components } from '@mui/material/styles';

export const MuiMenu: Components<Theme>['MuiMenu'] = {
  defaultProps: {
    slotProps: {
      paper: { elevation: 1 },
    },
  },
};
